/* tslint:disable */
/* eslint-disable */
/**
 * Kynward API
 * API for managing user gatherings, matching, and partner assignments.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, readWireField } from '../runtime';
/**
 * 
 * @export
 * @interface HandlersFullReleaseWaitlistSignupResponse
 */
export interface HandlersFullReleaseWaitlistSignupResponse {
    /**
     * 
     * @type {boolean}
     * @memberof HandlersFullReleaseWaitlistSignupResponse
     */
    alreadyRegistered?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HandlersFullReleaseWaitlistSignupResponse
     */
    created?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HandlersFullReleaseWaitlistSignupResponse
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HandlersFullReleaseWaitlistSignupResponse
     */
    ok?: boolean;
}

/**
 * Check if a given object implements the HandlersFullReleaseWaitlistSignupResponse interface.
 */
export function instanceOfHandlersFullReleaseWaitlistSignupResponse(value: object): value is HandlersFullReleaseWaitlistSignupResponse {
    return true;
}

export function HandlersFullReleaseWaitlistSignupResponseFromJSON(json: any): HandlersFullReleaseWaitlistSignupResponse {
    return HandlersFullReleaseWaitlistSignupResponseFromJSONTyped(json, false);
}

export function HandlersFullReleaseWaitlistSignupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HandlersFullReleaseWaitlistSignupResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'alreadyRegistered': readWireField(json, 'already_registered', 'alreadyRegistered') == null ? undefined : readWireField(json, 'already_registered', 'alreadyRegistered'),
        'created': readWireField(json, 'created', 'created') == null ? undefined : readWireField(json, 'created', 'created'),
        'id': readWireField(json, 'id', 'id') == null ? undefined : readWireField(json, 'id', 'id'),
        'ok': readWireField(json, 'ok', 'ok') == null ? undefined : readWireField(json, 'ok', 'ok'),
    };
}

export function HandlersFullReleaseWaitlistSignupResponseToJSON(json: any): HandlersFullReleaseWaitlistSignupResponse {
    return HandlersFullReleaseWaitlistSignupResponseToJSONTyped(json, false);
}

export function HandlersFullReleaseWaitlistSignupResponseToJSONTyped(value?: HandlersFullReleaseWaitlistSignupResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alreadyRegistered': value['alreadyRegistered'],
        'created': value['created'],
        'id': value['id'],
        'ok': value['ok'],
    };
}

